import React from 'react';
import { MIconInteractiveProps } from './MIconInteractive.types';
import * as Styled from './MIconInteractive.styles';
import { AIcon } from '../../atoms/AIcon';

const COMPONENT_NAME = 'MIconInteractive';
const TEST_ID = 'm-icon-interactive';

export function MIconInteractive({ aIcon, onClick }: MIconInteractiveProps) {
  return (
    <Styled.Wrapper onClick={onClick} data-component-name={COMPONENT_NAME} data-testid={TEST_ID}>
      {aIcon && <AIcon {...aIcon} />}
    </Styled.Wrapper>
  );
}
